import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-13" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-14" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-15" data-mp="avd0itzoq0d6">
          <span aria-hidden="true" data-id="element-16" data-mp="fsv9ulhm6hlp">🎁 </span>5 Exclusive Strategic Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-17" data-mp="1u598vvl5zsl">
          Total value{' '}
          <span className="font-bold text-amber-700 line-through" data-id="element-18" data-mp="5wi7z0bx0xfv">
            $193 USD
          </span>{' '}
          — included today for{' '}
          <span className="font-bold text-brand" data-id="element-19" data-mp="3o3fye0h2f3kw">FREE</span>
        </p>

        <ol className="mt-9 space-y-4" data-id="element-20" data-mp="3t1rdapm7w49z">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-start gap-4 rounded-2xl bg-white p-5 shadow-[0_1px_3px_rgba(23,15,20,0.06)]" data-id="element-21" data-mp="1m9ywldfm8wy2" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-22" data-mp="3ie6gdcxu9ttk">
                {index + 1}
              </span>
              <div className="min-w-0" data-id="element-23" data-mp="3r6qgkhts46gi">
                <h3 className="font-display text-base font-bold leading-snug text-ink" data-id="element-24" data-mp="3r5gihsmxey9v">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-ink/55" data-id="element-25" data-mp="3n7iswop8ua5y">
                  {bonus.text}
                </p>
                <p className="mt-2 text-[11px] font-bold" data-id="element-26" data-mp="2ugr3ca2oojrl">
                  <span className="text-amber-700 line-through" data-id="element-27" data-mp="2uibxvzp002pg">
                    Value {bonus.was}
                  </span>{' '}
                  <span className="text-brand" data-id="element-28" data-mp="33hffez8ioa1u">FREE</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}